import PropTypes from 'prop-types';
import React from 'react';
import View from '@loggi/ui/components/view';
import colors from '@loggi/ui/components/utils/colors';

const DEFAULT_SIZE = 1;
const HORIZONTAL_DIRECTION = 'horizontal';
const VERTICAL_DIRECTION = 'vertical';
const BORDER_TOP = 'borderTop';
const BORDER_LEFT = 'borderLeft';

const DIRECTIONS = [HORIZONTAL_DIRECTION, VERTICAL_DIRECTION];

class Divider extends React.Component {
  static displayName = 'Divider';

  static propTypes = {
    color: PropTypes.oneOf(colors.typeOptions),
    size: PropTypes.number,
    direction: PropTypes.oneOf(DIRECTIONS)
  };

  static defaultProps = {
    color: colors.type.DARKEST,
    size: DEFAULT_SIZE,
    direction: HORIZONTAL_DIRECTION
  };

  render() {
    const { color, size, direction } = this.props;
    const borderSide =
      direction === HORIZONTAL_DIRECTION ? BORDER_TOP : BORDER_LEFT;
    const hrStyle = __NATIVE__
      ? {
          borderWidth: 0, // cleanup borders
          margin: 0,
          [`${borderSide}Width`]: size,
          borderColor: colors.hex[color],
          height: borderSide === BORDER_TOP ? 'auto' : '100%'
        }
      : {
          borderWidth: 0, // cleanup borders
          margin: 0,
          [borderSide]: `${size}px solid ${colors.hex[color]}`,
          height: borderSide === BORDER_TOP ? 'auto' : '100%'
        };
    if (__NATIVE__) {
      return <View style={hrStyle} />;
    }
    return <hr style={hrStyle} />;
  }
}

export default Divider;
